import {useState} from 'react';
import getAxios from '../../../util/axios/getAxios';
import getFirebaseToken from '../../../util/firebase/getFirebaseToken';

export interface ImportResult {
  jobId: string;
  itemCount: number;
}

export default function useImportGoogleSheetToEtsyListings() {
  const [loading, setLoading] = useState(false);

  const importFromSheet = async (linkId: string): Promise<ImportResult> => {
    setLoading(true);
    try {
      const token = await getFirebaseToken();
      if (!token) throw new Error('Not authenticated');
      const response = await getAxios('etsy', {token}).post<ImportResult>('importGoogleSheetToEtsyListings', {
        linkId,
      });
      return response.data;
    } finally {
      setLoading(false);
    }
  };

  return [importFromSheet, {loading}] as const;
}
